<template>
  <section
    class="login-btn-wrapper flex-col-center"
    :class="[fissionStyleGame, displayLayout]"
  >
    <common-btn
      btnText="Google"
      class="login-btn google"
      @click="goLogin('google')"
      :hasTips="false"
      :type="type"
    />
    <!-- <common-btn
      v-show="region !== 'ru'"
      btnText="Facebook"
      class="login-btn facebook"
      @click="goLogin('facebook')"
      :hasTips="false"
      :type="type"
    /> -->
    <common-btn
      v-show="region === 'ru'"
      btnText="VK"
      class="login-btn vk"
      @click="goLogin('vk')"
      :hasTips="false"
      :type="type"
    />
  </section>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import CommonBtn from './index.vue'
  import { normalizeFissionStyleGame } from '../../configData'

  export default {
    props: {
      type: {
        type: String,
        default: 'page', // page: 页面, popup: 弹框
      },
    },
    components: {
      CommonBtn,
    },

    computed: {
      ...mapState(['region', 'fissionGame']),
      ...mapGetters(['displayLayout']),
      fissionStyleGame() {
        return normalizeFissionStyleGame(this.fissionGame)
      },
    },
    methods: {
      goLogin(type) {
        this.$emit('click', type)
      },
    },
  }
</script>
<style scoped lang="scss">
  .page.giftCard-wrapper .login-btn-wrapper {
    // 未登录状态访问裂变页
    position: static;
    background: none;
  }
  .login-btn-wrapper {
    margin-top: 0;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 523px;
    box-sizing: border-box;

    &.popup-card {
      border-radius: 0px 0px 30px 30px;
      .google.common-btn-wrapper {
        margin-bottom: 0;
      }
      &.only-one {
        height: 364px;
        padding-bottom: 95px;
      }
      &.only-three.mobile-layout,
      &.only-two.mobile-layout {
        padding-top: 160px;
        padding-bottom: 90px;
      }
    }
    &.genshin {
      background: linear-gradient(
        180deg,
        rgba(96, 105, 134, 0) 0%,
        rgba(96, 115, 134, 0.8) 43.89%,
        #606986 100%
      );
      &.popup-card {
        background: linear-gradient(
          180deg,
          rgba(127, 135, 161, 0) 0%,
          rgba(96, 105, 134, 0.8) 100%
        );
        &.guest-popup {
          background: none;
        }
      }
      &.gt-layout.only-one {
        background: none;
      }
    }
    &.pubgm {
      background: linear-gradient(
        180deg,
        rgba(4, 4, 4, 0) 0%,
        #040404 43.89%,
        #040404 100%
      );
      &.gt-layout {
        background: linear-gradient(
          180deg,
          rgba(4, 4, 4, 0) 0%,
          rgba(4, 4, 4, 0.5) 43.89%,
          rgba(4, 4, 4, 0.5) 100%
        );
      }
    }
    &.mobile-legends {
      background: linear-gradient(
        180deg,
        rgba(12, 6, 80, 0) 0%,
        rgba(24, 17, 113, 0.51) 43.89%,
        #050045 100%
      );
    }
    .common-btn-wrapper.popup {
      .common-btn {
        height: 114px;
      }
    }
    &.gt-layout {
      &.popup-card {
        &.only-one,
        &.only-two,
        &.only-three {
          height: auto;
          padding-bottom: 40px;
        }
        .login-btn {
          height: auto;
        }
      }
      .common-btn-wrapper.popup {
        .common-btn {
          width: 420px;
          height: 98px;
        }
      }
    }
  }
</style>
